import React from 'react'
import { styled } from '@mui/material'
import { MenuItem } from '@mui/material'

export const QuickNavMenuWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    margin: '10px',
    flexWrap: 'wrap',
})

export const QuickNavMenuTitle = styled('div')({
  color: 'rgba(28, 61, 100, 1)',
  fontSize: '22px',
  letterSpacing: '0.15px',
  fontWeight: 300,
  display: 'flex',
  padding: '10px',
  cursor: 'pointer',
  borderRadius: '4px',
  alignItems: 'center',
  '&:hover' : {
    backgroundColor: 'rgba(235, 245, 255, 1)'
  },
});

export const QuickNavMenuItem = styled(MenuItem)({
  minWidth: '250px',
  color: 'rgba(28, 61, 100, 1)',
  fontSize: '15px',
  fontWeight: '500',
  padding: '10px 10px 10px 20px',
  '&:hover' : {
    backgroundColor: 'rgba(235, 245, 255, 1)'
  },
})



